import React from "react";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

const ContactPage = () => {
  return (
    <div>
      <PageHero
        eyebrow="Let's Talk"
        title="Put your data on the pedestal"
        subtitle="Take control of your data and build reliable systems that empower your teams and drive better business outcomes."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Contact" }]}
        compact
      />
      <Contact hideHeader />
    </div>
  );
};

export default ContactPage;
